/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_difference_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Between 6 and 14: (|6 − 14| ÷ 10) × 100 = 80%.`)
};

const es_pct_difference_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entre 6 y 14: (|6 − 14| ÷ 10) × 100 = 80%.`)
};

const de_pct_difference_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zwischen 6 und 14: (|6 − 14| ÷ 10) × 100 = 80%.`)
};

const nl_pct_difference_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tussen 6 en 14: (|6 − 14| ÷ 10) × 100 = 80%.`)
};

const fr_pct_difference_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entre 6 et 14 : (|6 − 14| ÷ 10) × 100 = 80 %.`)
};

const it_pct_difference_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tra 6 e 14: (|6 − 14| ÷ 10) × 100 = 80%.`)
};

const pt_br2_pct_difference_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entre 6 e 14: (|6 − 14| ÷ 10) × 100 = 80%.`)
};

const pt_pct_difference_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entre 6 e 14: (|6 − 14| ÷ 10) × 100 = 80%.`)
};

const ja_pct_difference_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6と14の間: (|6 − 14| ÷ 10) × 100 = 80%。`)
};

const zh_pct_difference_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6 和 14 之间：(|6 − 14| ÷ 10) × 100 = 80%。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_difference_ex3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_difference_ex3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_difference_ex3", locale)
	if (locale === "en") return en_pct_difference_ex3(inputs)
	if (locale === "es") return es_pct_difference_ex3(inputs)
	if (locale === "de") return de_pct_difference_ex3(inputs)
	if (locale === "nl") return nl_pct_difference_ex3(inputs)
	if (locale === "fr") return fr_pct_difference_ex3(inputs)
	if (locale === "it") return it_pct_difference_ex3(inputs)
	if (locale === "pt-BR") return pt_br2_pct_difference_ex3(inputs)
	if (locale === "pt") return pt_pct_difference_ex3(inputs)
	if (locale === "ja") return ja_pct_difference_ex3(inputs)
	return zh_pct_difference_ex3(inputs)
};